import React from "react"
import MuiAvatar from "@material-ui/core/Avatar"
import { Badge } from "@material-ui/core"
import { withStyles } from "@material-ui/styles"
import { Avatar, Icon } from ".."
import { useAuth } from "../../services"

const StyledBadge = withStyles(() => ({
  badge: {
    right: 5,
    top: 5,
  },
}))(Badge)

const NotificationFrom = ({ notification }) => {
  const avatar = NotificationFromAvatar(notification)
  return notification.read ? (
    avatar
  ) : (
    <StyledBadge color="secondary" variant="dot" content=" ">
      {avatar}
    </StyledBadge>
  )
}

const NotificationFromAvatar = ({ from, className }) => {
  const {
    settings: { organisation },
  } = useAuth()

  if (from) {
    return <Avatar {...from} className={className} />
  }
  if (organisation.logo) {
    return <Avatar avatar={{ key: organisation.logo }} fullName={organisation.name} className={className} />
  }
  return (
    <MuiAvatar style={{ backgroundColor: "#fff" }}>
      <Icon name="operandio" size={33} />
    </MuiAvatar>
  )
}

export default NotificationFrom
export { NotificationFromAvatar }
